// extracted by mini-css-extract-plugin
export default {"asteriskIndicator":"NMoIsRSH6WSPlCbvzDdQ","messageBox":"nIfFtO6ljH1CG4oIi3kc"};